import React from "react";
import { SCROLL_OFFSET } from "./sections";
import image1 from "./Assets/image1.png";
import image2 from "./Assets/image2.png";
import image3 from "./Assets/image3.png";
import image4 from "./Assets/image4.png";
import image5 from "./Assets/image5.png";

// The exported PNGs are @2x and bake in the tile's drop shadow, so the opaque
// tile sits inside a larger transparent canvas. These measurements let us lay
// out the tile itself at its Figma size while the shadow bleeds outside the
// layout box. Values are fractions of the tile, so they scale with the box.
const SMALL_TILE = { frac: 0.56354, offsetX: 0.38235, offsetY: 0.17647 };
const LARGE_TILE = { frac: 0.41096, offsetX: 0.71667, offsetY: 0.35833 };

const APPS = [
  { src: image1, alt: "Google Docs", tile: SMALL_TILE, large: false },
  { src: image2, alt: "Gmail", tile: SMALL_TILE, large: false },
  { src: image3, alt: "Slack", tile: SMALL_TILE, large: false },
  { src: image4, alt: "Zero Typing AI", tile: LARGE_TILE, large: true },
  { src: image5, alt: "AI chat tools", tile: SMALL_TILE, large: false },
];

const AppIcon = ({ src, alt, tile, large }) => (
  <span
    className={`relative block shrink-0 ${
      large
        ? "h-[44px] w-[44px] sm:h-[60.095px] sm:w-[60.095px]"
        : "h-[38px] w-[38px] sm:h-[51.51px] sm:w-[51.51px]"
    }`}
  >
    <img
      src={src}
      alt={alt}
      className="absolute max-w-none"
      style={{
        width: `${100 / tile.frac}%`,
        left: `${-tile.offsetX * 100}%`,
        top: `${-tile.offsetY * 100}%`,
      }}
    />
  </span>
);

const SpeechToTextExtensionSection = () => {
  return (
    <section
      id="speech-to-text-extension"
      style={{ scrollMarginTop: `${SCROLL_OFFSET}px` }}
      className="w-full lg:max-w-[815.58px]"
    >
      <h2 className="font-jakarta font-bold text-[#0A0D16] text-[28px] sm:text-[36px] md:text-[44px] lg:text-[50px] leading-[1.28] lg:leading-[64px] tracking-[-0.8px]">
        A Speech-to-Text Google Docs Extension Built for Real Work
      </h2>

      <p className="mt-[25.76px] font-inter text-[16px] font-normal leading-[29.6px] tracking-[0px] text-[#0A0D16B2]">
        Zero Typing AI isn&apos;t limited to Google Docs. The same voice typing
        tool works across Gmail, Slack, and your favorite AI chat tools, so you
        get one consistent dictation experience everywhere you write instead of
        learning a different tool for every app.
      </p>

      <p className="mt-[25.76px] font-inter text-[16px] font-normal leading-[29.6px] tracking-[0px] text-[#0A0D16B2]">
        But Google Docs is where most long-form writing happens, and that&apos;s
        exactly where Zero Typing AI performs best: extended sessions, multiple
        paragraphs, and documents you&apos;ll actually publish or send without a
        heavy edit pass afterward.
      </p>

      {/* App strip — 30.05px top padding */}
      <div className="pt-[30.05px]">
        <div className="rounded-[17.17px] border-[1.34px] border-[#E6ECF5] bg-[#3AB1F61A] p-[20px] sm:p-[34.34px]">
          <div className="flex flex-wrap items-center justify-center gap-[14px] sm:gap-[25.76px]">
            {APPS.map((app) => (
              <AppIcon key={app.alt} {...app} />
            ))}
          </div>

          <p className="mt-[18px] sm:mt-[25.76px] text-center font-jakarta text-[11px] sm:text-[12px] font-normal leading-[18px] tracking-[0px] text-[#0A0D1699]">
            Google Docs · Gmail · Slack · AI chat tools
          </p>
        </div>
      </div>
    </section>
  );
};

export default SpeechToTextExtensionSection;
